import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import * as ModelAction from '../../store/actions/ModelAction'
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import * as DateTool from '../../util/DateTool';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';


import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';

import itLocale from "date-fns/locale/it";

const styles = theme => ({

    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    table: {
        // minWidth: 650,
    },
    tableHead: {
        background: "#b9b9b9"
    },

    row: {
        '&:hover': {
            background: "#CACACA"
        }
    },
    cell: {
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    modal: {
        display: 'block',
        position: 'absolute',
        overflow: 'scroll',
    },
    modalpaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 900,
    },
    buttonback: {
        backgroundColor: "#b9b9b9",
        border: '0px solid #000',
        boxShadow: theme.shadows[0],
        padding: theme.spacing(1.5, 1.5, 1.5),

    },
    formControlS: {
        margin: theme.spacing(1),
        width: 120,
    },
    formControlM: {
        margin: theme.spacing(1),
        width: 300
    },
    formControlL: {
        margin: theme.spacing(1),
        width: 800
    },
    grammar: {
        width: 800
    },
    grammarPreview: {
        width: 800
    },
    cell_short: {
        fontSize: "10px",
        width: 50,
    },
    cell_medium: {
        fontSize: "10px",
        width: 100,
    },
    cell_clickable: {
        cursor: "pointer"
    },
    cell_searched: {
        background: "#FA8072"
    },
    gridItem: {
    },
    button: {
        background: 'white',
        borderRadius: 3,
        border: 0,
        color: 'black',
        padding: '0 20px',
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    container: {
        maxHeight: 600,
    },
});

const customTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#bfbfbf',
            light: '#969696',
            dark: '#616060',
        },
        secondary: {
            main: '#616060',
        },
    },
})




var defaultFormValue = {};

class SimpleCrudModalCreate extends Component {

    constructor(props) {
        super(props);

        var submitDisabled = false

        Object.keys(this.props.modelProps.props).forEach((k) => {

            if (k != "id") {
                switch (this.props.modelProps.props[k].type) {
                    case "number":
                        defaultFormValue[k] = 0;
                        return;
                    case "string":
                        if (this.props.modelProps.props[k].defaultValue) {
                            defaultFormValue[k] = this.props.modelProps.props[k].defaultValue;
                        } else {
                            defaultFormValue[k] = "";
                        }
                        return;
                    case "date":
                        defaultFormValue[k] = DateTool.createJSONDateWithoutTime(new Date());
                        return;
                    case "time":
                        defaultFormValue[k] = DateTool.createJSONDateWithoutTime(new Date());
                        return;
                    case "select":
                        defaultFormValue[k] = "";
                        return;

                }


            }


        })

        this.state = null;
        this.state = {
            formValue: defaultFormValue,
            unfilledRequiredFIeld: false,
            openCreateModal: false,

        };

    }

    componentDidMount() {

    }


    handlCreateModalOpen = () => {
        this.setState({
            openCreateModal: true,
            formValue: Object.create(defaultFormValue),
            unfilledRequiredFIeld: false
        })
    };



    handleModalClose = () => {
        this.setState({ openCreateModal: false })
    };



    onChangeInputCommon = (e, key) => {
        e.preventDefault();
        var newFormValue = this.state.formValue;
        newFormValue[key] = e.target.value;
        this.setState({ formValue: newFormValue });
        //たぶんこれのせいで遅い
        //this.checkInputRequired();
    }
    handleDateTimeChange = (datetime, key) => {

        var newFormValue = this.state.formValue;

        if (datetime == null || datetime == "") {
            newFormValue[key] = null;
        } else {
            newFormValue[key] = DateTool.createJSONDateWithoutTime(datetime);
        }
        this.setState({ formValue: newFormValue });

    }

    bk_checkInputRequired = () => {

        var submitDisabled = false

        Object.keys(this.props.modelProps.props).forEach((k) => {

            if (k != "id") {
                //入力必須項目に入力があるか→なければCreateボタン非活性
                if (this.props.modelProps.props[k].inputRequired == true) {

                    switch (this.props.modelProps.props[k].type) {
                        case "number":
                            if (this.state.formValue[k] == 0) {
                                submitDisabled = true
                            }
                            return;
                        case "string":
                            if (this.state.formValue[k] == "") {
                                submitDisabled = true
                            }
                            return;
                        case "date":
                            if (this.state.formValue[k] == "") {
                                submitDisabled = true
                            }
                            return;
                        case "time":
                            if (this.state.formValue[k] == "") {
                                submitDisabled = true
                            }
                            return;
                        case "option":
                            if (this.state.formValue[k] == "") {
                                submitDisabled = true
                            }
                            return;
                    }
                }
            }

        })

        this.setState({ submitDisabled: submitDisabled });
    }

    checkInputRequired = () => {

        var unfilledRequiredFIeld = false

        Object.keys(this.props.modelProps.props).forEach((k) => {

            if (k != "id") {
                //入力必須項目に入力があるか
                if (this.props.modelProps.props[k].inputRequired == true) {
                    console.log('入力必須', this.props.modelProps.props[k])

                    switch (this.props.modelProps.props[k].type) {
                        case "number":
                            if (this.state.formValue[k] == 0) {
                                unfilledRequiredFIeld = true
                            }
                            return;
                        case "string":
                            if (this.state.formValue[k] == "") {
                                unfilledRequiredFIeld = true
                            }
                            return;
                        case "date":
                            if (this.state.formValue[k] == "") {
                                unfilledRequiredFIeld = true
                            }
                            return;
                        case "time":
                            if (this.state.formValue[k] == "") {
                                unfilledRequiredFIeld = true
                            }
                            return;
                        case "select":
                            if (this.state.formValue[k] == "") {
                                unfilledRequiredFIeld = true
                            }
                            return;
                    }
                }
            }

        })

        this.setState({ unfilledRequiredFIeld: unfilledRequiredFIeld });

        return unfilledRequiredFIeld
    }

    render() {

        var keys = Object.keys(this.props.modelProps.props);

        const { classes } = this.props;

        const nums = [];
        for (let i = 1; i <= 50; i++) {
            nums.push(i);
        }

        return (
            <div>
                <List>
                    <ListItem button key="Lessons" onClick={(e) => { e.preventDefault(); this.handlCreateModalOpen() }}>
                        <ListItemIcon>
                            <AddIcon />
                        </ListItemIcon>
                        <ListItemText primary="Aggiunta" />
                    </ListItem>
                </List>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={this.state.openCreateModal}
                    onClose={this.handleModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={this.state.openCreateModal}>
                        <div className={classes.modalpaper}>
                            <form className={classes.root} noValidate autoComplete="on">
                                <Grid container justify="left"  >
                                    <Grid item xs={12}  >
                                        <h4 id="transition-modal-title">{this.props.modelName}</h4>
                                    </Grid>

                                    {keys.map((key) => {
                                        if (key != "id" && key != "DefaultNum") {

                                            //表示ラベルの設定がある場合はそれを適用
                                            var label = this.props.modelProps.props[key].label ? this.props.modelProps.props[key].label : key

                                            if (this.props.modelProps.props[key].inputRequired == true) {
                                                label = label + "*"
                                            }

                                            switch (this.props.modelProps.props[key].type) {
                                                case "number":
                                                    return (
                                                        <Grid item xs={12} key={'form_' + key}  >
                                                            <FormControl className={classes.formControlS}>
                                                                <TextField
                                                                    id="standard-basic"
                                                                    label={label}
                                                                    value={this.state.formValue[key]}
                                                                    onChange={(e) => { this.onChangeInputCommon(e, key) }}
                                                                />
                                                            </FormControl>
                                                        </Grid>)
                                                case "string":
                                                    return (
                                                        <Grid container key={'form_' + key}>
                                                            <Grid item xs={12} >
                                                                <FormControl className={classes.formControlL}>
                                                                    <TextField
                                                                        className={classes.grammar}
                                                                        id="outlined-basic"
                                                                        label={label}
                                                                        variant="outlined"
                                                                        value={this.state.formValue[key]}
                                                                        onChange={(e) => { this.onChangeInputCommon(e, key) }} />
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    )

                                                case "date":
                                                    return (<Grid item xs={12} key={'form_' + key}  >
                                                        <FormControl className={classes.formControlM}>
                                                            <MuiThemeProvider theme={customTheme}>
                                                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={itLocale}>
                                                                    <KeyboardDatePicker
                                                                        margin="normal"
                                                                        id="date-picker-dialog"
                                                                        label={label}
                                                                        format="dd/MM/yyyy"
                                                                        value={this.state.formValue[key]}
                                                                        onChange={(e) => { this.handleDateTimeChange(e, key) }}
                                                                        KeyboardButtonProps={{
                                                                            'aria-label': 'change date',
                                                                        }}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </MuiThemeProvider>
                                                        </FormControl>
                                                    </Grid>)
                                                case "time":
                                                    return (<Grid item xs={12} key={'form_' + key}  >
                                                        <FormControl className={classes.formControlS}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={itLocale}>
                                                                <KeyboardTimePicker
                                                                    margin="normal"
                                                                    id="time-picker"
                                                                    label={label}
                                                                    value={this.state.formValue[key]}
                                                                    onChange={(e) => { this.handleDateTimeChange(e, key) }}
                                                                    KeyboardButtonProps={{
                                                                        'aria-label': 'change time',
                                                                    }}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </FormControl>
                                                    </Grid>)
                                                case "select":
                                                    return (<Grid item xs={12} key={'form_' + key} >
                                                        <FormControl className={classes.formControlS}>
                                                            <FormLabel component="legend">{label}</FormLabel>
                                                            <RadioGroup aria-label={key} name={key} value={this.state.formValue[key]} onChange={(e) => { this.onChangeInputCommon(e, key) }}>
                                                                {
                                                                    this.props.modelProps.props[key].option.map((op) => {
                                                                        return (
                                                                            <FormControlLabel key={'key_' + op.val} value={op.val} control={<Radio />} label={op.label} />
                                                                        )
                                                                    })
                                                                }
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>)
                                            }
                                        }
                                    })}

                                    {this.state.openCreateModal &&
                                        <Grid item xs={12} >
                                            <Button variant="contained"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    console.log("this.props", this.props)

                                                    //未入力の必須項目が存在するか
                                                    var unfilledRequiredFIeld = this.checkInputRequired()
                                                    if (unfilledRequiredFIeld) {

                                                    } else {
                                                        this.props.submitCreate(
                                                            this.props.socket, 
                                                            this.props.modelProps, 
                                                            this.state.page, 
                                                            this.state.numData, 
                                                            this.state.formValue, 
                                                            this.props.modelProps, 
                                                            this.props.logininfo.id
                                                        );
                                                        this.handleModalClose();
                                                    }

                                                }}>Create</Button>
                                        </Grid>
                                    }
                                    {this.state.unfilledRequiredFIeld &&
                                        <Grid item xs={12} ><div className={classes.formControlM}><font color="#F50057">Please fill in the required sections *</font></div></Grid>}
                                </Grid >
                            </form>
                        </div>
                    </Fade>
                </Modal >

            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        logininfo: state.auth.logininfo

    }
}

const mapDispatchToProps = (dispatch) => {

    return {

        submitCreate: (socket, getModelProps, page, numData, formValue,postModelProps, access_token) => {
            dispatch(ModelAction.apiPost(socket, getModelProps, page, numData, formValue,postModelProps, access_token))
        },

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(SimpleCrudModalCreate));